import Vue from "vue";
import Router from "vue-router";
import Numbercenter from "./views/Numbercenter.vue";
import Order from "./views/Order.vue";
import OrderList from "./pages/order/orderlist.vue";
import OrderInfo from "./pages/order/orderinfo.vue";
// import StepOne from "./pages/numbercenter/stepOne.vue";
// import StepTwo from "./pages/numbercenter/stepTwo.vue";
// import StepThree from "./pages/numbercenter/stepThree.vue";
// import StepFour from "./pages/numbercenter/stepFour.vue";
// import Addlist from "./views/Addlist.vue";
Vue.use(Router);

export default new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "numbercenter",
      component: Numbercenter
    },
    {
      path: "/numbercenter",
      component: Numbercenter,
    },
    {
      path: "/order",
      name: "order",
      component: Order,
      children : [
        {
          path: "/",
          name: "orderlist",
          component: OrderList
        },
        {
          path: ":orderId",
          name: "orderinfo",
          component: OrderInfo
        }
      ]
    },
    // {
    //   path: "/addlist",
    //   name: "addlist",
    //   component: Addlist
    // },
    // {
    //   path: "/about",
    //   name: "about",
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () =>
    //     import(/* webpackChunkName: "about" */ "./views/About.vue")
    // }
  ]
});
